const React = require('react')
const config = require('../../../../config/')
const propTypes = require('prop-types');
const Helpers = require('../../../../_plugins/lib/helpers')
const { string } = propTypes
const createReactClass = require('create-react-class');

const EmailSignup = createReactClass({
  propTypes: {
    id: string.isRequired
  },

  getInitialState () {
    return {
      emailValue: '',
      errorMsg: 'Enter your email address',
      error: '',
      hideForm: false
    }
  },

  validateForm () {
    const { emailValue } = this.state
    if (emailValue === '') this.setState({ errorMsg: 'Please enter your email address', error: 'error'})
    const emailReg = new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)
    const emailValid = emailReg.test(emailValue)
    Helpers.setCookie('Email', emailValue)
    return emailValid
  },

  submitForm () {
    tracker.track('marketing', {
      marketing: {
        action: 'subscribe',
        agent_code: config.agents.responsys,
        country: 'uk',
        language: 'en',
        brand: 'AP',
        opt_in_message: 'ap_standard_signup',
        preferences: {
          frequency: 'fortnightly',
          method: ['email']
        }
      }
    })
    this.setState({
      hideForm: true
    })
  },

  handleChange (event) {
    this.setState({emailValue: event.target.value, error: ''})
  },

  handleSubmit (e) {
    e.preventDefault()
    this.validateForm() && this.submitForm()
  },

  render () {
    const { id } = this.props
    const { hideForm, error, errorMsg, emailValue } = this.state
    let content = (
      <form action='https://email.holidayextras.co.uk/pub/rf' target='_parent' className='clearfix' onSubmit={this.handleSubmit}>
        <div className='email'>
          <label forhtml='email'>Your email address</label>
          <input type='email' name='EMAIL_ADDRESS_' className='text email form-control' value={emailValue} placeholder={errorMsg} onChange={this.handleChange} data-error={error} />
          <p className='center-block help-text'>We treat <a href='/company/privacy-policy.html'>your privacy</a> very seriously!</p>
          <button type='submit' onClick={this.handleSubmit} className='btn btn-default'>Join now <i className='fa fa-envelope' /></button>
        </div>
      </form>
    )
    if (hideForm) {
      content = <p>Thank you for signing up, we’ve sent you an email.</p>
    }
    return (
      <div id={id}>
        {content}
      </div>
    )
  }
})

module.exports = EmailSignup





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/email-signup.jsx